export interface Currency {
  value: string;
  label: string;
}

export const Currencies: Currency[] = [
  { value: "INR", label: "INR" },
  { value: "USD", label: "USD" },
  { value: "EUR", label: "EUR" },
];
